module.exports = new __parcel__URL__("circle.d95eea97.svg").toString();